import Chart from "react-apexcharts";
import type { ApexOptions } from "apexcharts";
import type { ILineChart } from "./../../../../types/charts/chart/line_chart";
import type { IChartInternalProps } from "./../../../../types/charts/chart/internal-props";
import { deepObjectsMerge } from "./../../../../utils/deepObjectsMerge";
import { sharedOptions } from "../sharedOptions";

export const LineChart = ({
  series,
  options,
  categories,
  ...internalProps
}: ILineChart) => {
  const { colors, labels } = (internalProps as IChartInternalProps);

  const modifiedSeries = series?.map((item, index: number) => ({ ...item, name: labels?.[index] }));

  const localOptions: ApexOptions = {
    grid: {
      padding: {
        top: -15,
      }
    },
    stroke: {
      width: 2.5,
    },
    markers: {
      hover: {
        size: 4,
      }
    },
    colors: colors,
    xaxis: {
      categories: categories,
      axisTicks: {
        show: true,
      },
    },
  };

  const mergedOptions = deepObjectsMerge(sharedOptions, localOptions, (options ?? {}));

  return (
    <Chart
      options={mergedOptions}
      series={modifiedSeries}
      type="line"
      width="100%"
      height="100%"
    />
  )
}